<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <i class="icon-bell"></i>
      <b-badge v-if="unreadCount > 0" pill variant="danger">{{unreadCount}}</b-badge>
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>{{ $t('global.you_have') }} {{unreadCount}}
          {{ $t('global.new_notifications') }}</strong>
      </b-dropdown-header>
      <b-dropdown-item v-for="(notification, id) in notificationsData" :key="id" @click="open(id)"
                       :class="{'new': !notification.viewed}">
        <span class="datetime">{{ notification.created | moment('DD.MM.YYYY HH:mm') }}</span>
        <span class="text">{{ notification.text }}</span>
        <i class="fa fa-bell-o ico" @click.stop="markRead(id)" />
      </b-dropdown-item>
      <hr class="m-0">
      <b-dropdown-item-button class="text-center" @click="openAll">
        <span class="text">{{ $t('global.notifications_see_all') }}</span>
      </b-dropdown-item-button>

    </template>
  </AppHeaderDropdown>
</template>

<script>
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import { setInterval, clearInterval } from 'timers';
import { mapGetters, mapActions } from 'vuex';
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
import VT from '@/store/types';

const SEC = 1000;
const POLLING_INTERVAL = 10 * SEC;
export default {
  mounted() {
    this.getData();
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  data() {
    return {
      unreadCount: 0,
      notificationsData: {}
    };
  },
  components: {
    AppHeaderDropdown
  },
  computed: {
    ...mapGetters('Notifications', [
      'notificationsNew',
      'notificationsReadUpdate',
      'routeMap'
    ]),
    ...mapGetters('Auth', [
      'isLoggedIn',
    ]),
  },
  watch: {
    notificationsNew: {
      handler: function () {
        if (this.notificationsNew.status === statuses.LOADED) {
          this.fillData();
        }
      },
      deep: true
    },
    notificationsReadUpdate: {
      handler: function () {
        if (this.notificationsReadUpdate.status === statuses.LOADED) {
          this.getData();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Notifications', [
      VT.NOTIFICATIONS_NEW,
      VT.NOTIFICATION_READ_UPDATE,
    ]),
    getData() {
      if (this.isLoggedIn) this.NOTIFICATIONS_NEW();
    },
    fillData() {
      const result = {};
      if (this.notificationsNew.data.notifications && this.notificationsNew.data.notifications.length) {
        this.unreadCount = this.notificationsNew.data['totalUnread'];
        forEach(this.notificationsNew.data.notifications, (item) => {
          if (!result[item.id]) {
            result[item.id] = {};
          }
          result[item.id] = {
            viewed: !!item['readAt'],
            text: item['title'],
            created: item['createdAt'],
            type: item['type'],
            externalId: item['externalId']
          };
        });
      }
      this.notificationsData = result;
    },
    markRead(id) {
      this.NOTIFICATION_READ_UPDATE({ type: 1, ids: [id] });
    },
    open(idx) {
      this.markRead(idx);
      this.goto(idx);
    },
    openAll() {
      this.$router.push({ name: 'Notifications' });
    },
    goto(idx) {
      const item = this.notificationsData[idx];
      if (item['externalId']) {
        this.$router.push({
          name: this.routeMap[item['type']],
          params: {
            id: item['externalId']
          },
        });
      }
    },
    startPolling() {
      this.stopPolling();

      this.pollInterval = setInterval(() => {
        this.getData();
      }, POLLING_INTERVAL);
    },
    stopPolling() {
      clearInterval(this.pollInterval);
    },
  }
};
</script>
<style lang="scss" scoped>
  .dropdown-menu {
    .dropdown-item {
      &:active {
        background: transparent;
        color: #000;
      }
    }
    .ico {
      color: #c8ced3;
      right: 2px;
      top: 7px;
      position: absolute;
      padding: 5px;
    }
    .new {
      .text {
        font-weight: bold;
      }
      .ico {
        color: #000;

        &:hover {
          color: #c8ced3;
        }
      }
    }
    .text {
      padding: 0 20px 0 10px;
    }
  }
</style>
